import { cva } from "class-variance-authority";

/**
 * Accordion Variants
 *
 * V&A Waterfront Design System - Accordion Component
 * Figma: https://www.figma.com/design/CV2ePEn9S0SSZ7T3AAPqF4/V-A-Waterfront---Website---Foundation-Design-System?node-id=10640-4285
 *
 * Design specs:
 * - Desktop: py-8 (32px), gap-8 (32px between trigger and content)
 * - Mobile: py-6 (24px), gap-8 (32px between trigger and content)
 * - Border: border-t border-b border-border-subtle
 * - Trigger text: text-text-primary
 * - Content text: text-text-secondary
 */

/**
 * Styles for the accordion item container.
 */
export const accordionItemVariants = cva(
  ["border-b border-border-subtle", "first:border-t"],
  {
    variants: {},
    defaultVariants: {},
  },
);

/**
 * Styles for the accordion trigger (clickable header).
 */
export const accordionTriggerVariants = cva(
  [
    // Layout
    "flex flex-1 items-center justify-between",
    "w-full",
    // Spacing - Desktop: py-8 (32px), Mobile: py-6 (24px)
    "py-6 md:py-8",
    // Gap between text and chevron - Desktop: gap-8 (32px), Mobile: gap-6 (24px)
    "gap-6 md:gap-8",
    // Typography - Desktop: 18px medium, Mobile: 16px medium
    "typography-body-sm-medium md:typography-body-md-medium",
    "text-text-primary",
    // Interaction
    "cursor-pointer",
    "transition-colors duration-200",
    // Focus states
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2",
    // Disabled state
    "disabled:pointer-events-none disabled:opacity-50",
    // Chevron rotation on open state
    "[&[data-state=open]>svg]:rotate-180",
  ],
  {
    variants: {},
    defaultVariants: {},
  },
);

/**
 * Styles for the chevron icon.
 */
export const accordionChevronVariants = cva([
  "size-6 shrink-0",
  "text-icon-primary",
  "transition-transform duration-200",
]);

/**
 * Styles for the accordion content wrapper.
 */
export const accordionContentVariants = cva(
  [
    // Animation
    "overflow-hidden",
    "data-[state=closed]:animate-accordion-up",
    "data-[state=open]:animate-accordion-down",
  ],
  {
    variants: {},
    defaultVariants: {},
  },
);

/**
 * Styles for the accordion content inner container.
 */
export const accordionContentInnerVariants = cva(
  [
    // Spacing - padding bottom to match item padding
    "pb-6 md:pb-8",
    // Typography
    "typography-body-sm-regular",
    "text-text-secondary",
  ],
  {
    variants: {},
    defaultVariants: {},
  },
);
